import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css'],
  standalone: false
})
export class NotFoundComponent implements OnInit {

  urlBase: string;

  constructor(private location: Location) { }

  ngOnInit(): void {

  }

  voltar() {
    this.location.back();
  }

}
